var React = require('react');

function IconMin (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#1478a6;}")),React.createElement("title",{"key":1},"icon-min"),React.createElement("path",{"className":"cls-1","d":"M0,0V3.47H32V0H0","key":2})]);
}

IconMin.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 32 3.47"};

module.exports = IconMin;

IconMin.default = IconMin;
